import { useState } from 'react';
import Swatch from "../Swatch";
import { resolveSelectedLength } from "./lib/resolve-selected-length";
import { resolveSelectedWaist } from "./lib/resolve-selected-waist";
import { splitSizeOptionIntoWaistLength } from './lib/split-size-option-into-waist-length';

export function WaistLengthSelector({ heading, options, handleOptionChange, openSizeGuide, product }) {
    const [waist, setWaist] = useState(resolveSelectedWaist(options));
    const [length, setLength] = useState(resolveSelectedLength(options));
  
    const waistLengthOptions = splitSizeOptionIntoWaistLength(options, waist, length);
  
    // Intercepts handleOption and swatch and adjusts it back
    // to original option object
    const handleWaistLengthChange = (selected) => {
      if (selected.option === 'Waist') {
        setWaist(selected.waist);
        handleOptionChange({
          ...selected,
          value: `${selected.waist}/${length}`,
          key:  `${selected.waist}/${length}`,
          labelText: `${selected.waist}/${length}`,
          option: 'Size'
        });
        return;
      }
      setLength(selected.length);
        handleOptionChange({
          ...selected,
          value: `${waist}/${selected.length}`,
          key:  `${waist}/${selected.length}`,
          labelText: `${waist}/${selected.length}`,
          option: 'Size'
        });
  
    }
    return (
      <>
        <Swatch
          key={'waist'}
          handle={'size'}
          name={'waist'}
          data={waistLengthOptions['waist']}
          heading={'Waist'}
          updateVariant={handleWaistLengthChange}
          openSizeGuide={openSizeGuide}
          product={product}
        />

        <Swatch
          key={'length'}
          handle={'size'}
          name={'length'}
          data={waistLengthOptions['length']}
          heading={'Length'}
          updateVariant={handleWaistLengthChange}
          openSizeGuide={openSizeGuide}
          product={product}
        />
      </>
    );
  }